import SummarizedNav from './SummarizedNav'

export default SummarizedNav
